import PropTypes from 'prop-types';
import React from 'react';
import FluidImage from '@utility/FluidImage/index';
import ContentBox from '@components/ContentBox';
import Parallax from '@utility/Parallax';
import ScrollInView from '@utility/ScrollInView/index';
import Link from '@utility/Link';
import * as styles from './styles.module.scss';
import Logo from '../Logo';

const ImageTextOverlapFramed = ({ data: { contentBox, image, reverse } }) => (
  <div className={styles.overlapbox}>
    <div className="wrapper">
      <div
        className={`row flex-col-reverse md:flex-row ${
          reverse ? 'md:flex-row-reverse' : ''
        }`}
      >
        <ScrollInView className="col-10 md:col-5 relative z-10 md:mt-0 items-end flex">
          <div>
            <ContentBox data={contentBox} transparent={true} />
          </div>
        </ScrollInView>
        <ScrollInView className={`col-10 md-down:ml-6 md:col-5`}>
          <div className={styles.imgbox}>
            {contentBox && contentBox.link && contentBox.link[0] && (
              <Link
                internalExternal
                to={contentBox.link[0]}
                className="no-after"
                aria-label={contentBox.link[0].label}
              >
                {/* <FluidImage
                  src={image}
                  // maxWidth={1420}
                  // maxHeight={1064}
                  // className="h-full"
                /> */}
                <img src={image.asset.url} alt={image.altText || ''} />
              </Link>
            )}
            {(!contentBox || !contentBox.link || !contentBox.link[0]) && (
              <FluidImage src={image} maxWidth={1420} maxHeight={1064} />
            )}
          </div>
        </ScrollInView>
      </div>
    </div>
  </div>
);

ImageTextOverlapFramed.propTypes = {
  data: PropTypes.shape({
    heading: PropTypes.string,
    image: PropTypes.object.isRequired,
    contentBox: PropTypes.object.isRequired,
    reverse: PropTypes.bool,
  }),
};

ImageTextOverlapFramed.defaultProps = {
  data: {
    heading: '',
    reverse: false,
  },
};

export default ImageTextOverlapFramed;
